import { marked } from "marked";
import { slugify } from "cando-util";
import { tryEval } from 'cando-util';

export const getMarked = (markdown, useTryEval = true) => {
	const toc = [];
	let content = '';
	if (markdown) {
		const renderer = new marked.Renderer();

		// Intercept headers and add them to the TOC
		renderer.heading = (heading) => {
			const slug = slugify(heading.text);
			const link = `#${slug}`;
			toc.push({
				level: heading.depth,
				text: heading.text,
				slug
			});
			return `<h${heading.depth} id="${slug}">${heading.text}</h${heading.depth}>`;
		};

		if (useTryEval) {
			const evaluated = tryEval(markdown);
			content = typeof evaluated === "string" ? evaluated : markdown;
		}

		content = marked(content, { renderer });

	}
	return { toc, content };
};
